import {
  ContentLayout,
  CustomDetailsList,
  HeaderBreadcrumbs,
  PageNotFound,
  Loader,
  ErrorScreen,
  CustomeDialog,
  useTabs,
  LoadingButton,
} from "../../../shared";
import * as React from "react";
import { Button, Chip, Stack, Typography } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { useParams } from "react-router-dom";
import { useTandaDetails } from "../hooks/useTandaDetails";
import SimpleReactValidator from "simple-react-validator";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ConnectTandaDialog } from "../components/ConnectTandaDialog";
import moment from "moment";
import { SyncHistory } from "../components/SyncHistory";
import { SelectDataStreamDialog } from "../components/SelectDataStreamDialog";

export const TandaDetails = () => {
  const { id } = useParams();
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );
  const { setCurentTab } = useTabs();

  const {
    state,
    redirectURL,
    storeIdToUse,
    isEditable,
    isStoreAdmin,
    handleModal,
    onChange,
    handleStoreConnect,
    handleStoreDisconnect,
    onChangeDataStream,
    handleDataStreamSelect,
  } = useTandaDetails();

  const {
    isBusy,
    isDetails,
    errMsg,
    details,
    isOpenConnect,
    isSaveButton,
    isDataStreamOpen,
  } = state;

  const columns = [
    {
      title: "Store Name",
      accessor: "store",
      hidden: () => isStoreAdmin,
    },
    {
      title: "Application ID",
      accessor: (val) => {
        return val.application_id ? val.application_id : "--";
      },
    },
    {
      title: "Data Stream Name",
      accessor: (val) => {
        return val.data_stream_name ? val.data_stream_name : "--";
      },
      hidden: (val) => !val.status,
    },
    {
      title: "Data Stream ID",
      accessor: (val) => {
        return val.data_stream_id ? val.data_stream_id : "--";
      },
      hidden: (val) => !val.status,
    },
    {
      title: "Connected On",
      accessor: (val) => {
        return val.connected_on ? val.connected_on : "--";
      },
    },
  ];

  const tabs = React.useMemo(() => {
    return [
      {
        label: "Details",
        value: "1",
        panel: (
          <>
            <CustomDetailsList
              columns={columns}
              data={details}
              title="Details"
              headerRightContent={
                <>
                  {isEditable && (
                    <Stack direction="row" alignItems="center" gap="8px">
                      {details.status ? (
                        <>
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() => handleModal("dataStream", true)}
                          >
                            {details.data_stream_id
                              ? "Change Data Stream"
                              : "Select Data Stream"}
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={() => handleModal("disconnect", true)}
                          >
                            Disconnect
                          </Button>
                        </>
                      ) : (
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => handleModal("connect", true)}
                        >
                          Connect
                        </Button>
                      )}
                    </Stack>
                  )}
                </>
              }
            />
          </>
        ),
      },
      {
        label: "Sync History",
        value: "2",
        panel: <SyncHistory storeId={storeIdToUse} status={details?.status} />,
      },
    ];
  }, [details, storeIdToUse, isBusy, columns]);

  if (isBusy) {
    return <Loader />;
  }

  if (!isDetails) {
    return <ErrorScreen text={errMsg} />;
  }

  return (
    <>
      <ContentLayout
        title={details?.store}
        breadcrumbs={
          <HeaderBreadcrumbs
            links={[
              { name: "Dashboard", href: isStoreAdmin ? "/store-admin/" : "/" },
              !isStoreAdmin ? { name: "Tanda", href: "/tanda" } : null,
              { name: details?.store },
            ].filter(Boolean)}
          />
        }
        chipType={"other"}
        statusContent={
          <>
            <Chip
              label={state.details?.status ? "Connected" : "Disconnected"}
              variant="outlined"
              size="small"
              deleteIcon={
                state.details?.status ? (
                  <CheckCircleIcon sx={{ color: "#0F875B !important" }} />
                ) : undefined
              }
              onDelete={state.details?.status ? () => {} : undefined}
              sx={{
                border: "none !important",
                background: state.details?.status ? "#E1FBF2" : "#e6e6e6",
              }}
            />
          </>
        }
        rightContent={
          <>
            {details?.last_sync_was_on ? (
              <Typography
                color="#636363"
                variant="subtitle2"
                sx={{ display: "flex", gap: "6px" }}
              >
                <img alt="refres" src="/icons/ic_refresh.svg" />
                Last Synced: {details?.last_sync_was_on} &bull;{" "}
                <span
                  style={{ color: details?.status ? "#0F875B" : "#C42B1C" }}
                >
                  {details?.status ? "Success" : "Failure"}
                </span>
              </Typography>
            ) : (
              ""
            )}
          </>
        }
        tabProps={{
          label: "tandaDetails",
          list: tabs,
        }}
      />

      <CustomeDialog
        open={state?.isOpen}
        handleClose={() => handleModal("connect", false, null)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { width: "423px", p: "16px" },
        }}
        title="Connect to Tanda"
        content={
          <ConnectTandaDialog
            onChange={onChange}
            state={state}
            handleModal={handleModal}
            handleUpdate={() =>
              handleStoreConnect(details, details?.status ? false : true)
            }
            redirectURL={redirectURL}
          />
        }
      />

      {/* Data Stream Selection Modal */}
      <CustomeDialog
        open={isDataStreamOpen}
        handleClose={() => handleModal("dataStream", false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { width: "520px", p: "16px" },
        }}
        title="Select Data Stream"
        content={
          <SelectDataStreamDialog
            state={state}
            onChangeDataStream={onChangeDataStream}
            handleModal={handleModal}
            handleUpdate={handleDataStreamSelect}
          />
        }
      />

      {/* Disconnect Confirmation Modal */}
      <CustomeDialog
        open={isOpenConnect}
        handleClose={() => handleModal("disconnect", false)}
        PaperProps={{
          // Changed from dialogProps to PaperProps to match the other dialogs
          sx: { width: "423px", height: "155px", p: "16px" },
        }}
        title="Disconnect Tanda" // Changed from Alert to make it more specific
        content={
          <Stack
            mt="8px"
            gap="10px"
            height="100%"
            justifyContent="space-between"
          >
            <Typography variant="subtitle2">
              Are you sure you want to disconnect Tanda for{" "}
              {details?.store_name}?
            </Typography>
            <Stack direction="row" justifyContent="end" gap={2}>
              <Button
                variant="text"
                onClick={() => handleModal("disconnect", false)} // Corrected to match modal type
              >
                Cancel
              </Button>
              <LoadingButton
                loading={isSaveButton}
                variant="contained"
                color="error"
                onClick={handleStoreDisconnect} // No need to pass false here
              >
                Disconnect
              </LoadingButton>
            </Stack>
          </Stack>
        }
      />
    </>
  );
};
